export default __webpack_public_path__ + "static/media/3D.c857f587.svg";